<template>
  <div>
    <a class="backBtn" href="/#/">
      <img src="/img/back-icon.png" />
    </a>
    <div class="page-header header-filter">
      <div class="page-header-image spacecraft-background"
        :style="`background-image: url('/img/missions/${$route.params.missionId}-Preescolar.png')`" />
      <div class="container spacecraft-container" v-if="!isShowingTask">
        <div class="row spacecraft-row">
          <div @click="goToBook()" class="col-sm button-container books" style="background-color: cyan;
        margin-top: 3rem;">
            <img src="/img/botonLibro.png" width="100%" />
          </div>
          <div @click="goToReadBook()" class="col-sm button-container resources" style="background-color: magenta;
        margin-left: 3rem;
        margin-top: 3rem;
        transform:rotate(10deg);">
            <img src="/img/botonLecturas.png" width="100%" />
          </div>
        </div>
      </div>

      <slide-y-up-transition :duration="500">
        <div class="container spacecraft-container-glass" v-if="isShowingTask">
          <div class="mission-screen">
            <div class="row">
              <div class="row between w-100">
                <div class="col text-left">
                  <n-button type="primary" size="lg" round @click="clearTask()" label="Regresar"
                    icon-left="fas fa-arrow-left" />
                  <!-- <a href="#" class="link" @click="clearTask()">
                  <h3 class="mt-2 text-white cursor-pointer">
                    <i class="fas fa-arrow-left"></i> Regresar
                  </h3>
                </a> -->
                  <!-- jnkj -->
                </div>
                <!-- <div class="col mt-2">
                <h2>
                  <router-link to="/"><img src="/img/icons/favicon-white.png" width="10%"/></router-link>
                  {{taskType == 'activities' ? 'Actividades' : 'Recursos'}}
                </h2>
              </div> -->
                <div class="col text-right">
                  <n-button type="primary" size="lg" round @click="logout()" label="Cerrar sesión"
                    icon-right="fas fa-sign-out-alt" />
                </div>
              </div>

              <fade-transition :duration="200" mode="out-in">

                <div class="row" v-if="taskType == 'activities' && !isShowingVideo">
                  <!--<div class="col">
                  <card style="width: 20rem;">
                    <img slot="image" class="card-img-top" src="/img/demo/amigos_thumb.png" alt="Card image cap">
                    <div class="text-primary">
                      <h4 class="card-title">El obsequio ideal</h4>
                      <p class="card-text">
                        Ayuda a Paola a encontrar el regalo perfecto para cada uno de sus amigos.
                      </p>
                      <n-button type="primary" @click="goToActivities('1')">¡Vamos!</n-button>
                    </div>
                  </card>
                </div>-->

                  <div class="col">
                    <card style="width: 20rem;">
                      <img slot="image" class="card-img-top" src="/img/demo/amigos_thumb.png" alt="Card image cap">
                      <div class="text-primary">
                        <h4 class="card-title">Lectura: El obsequio ideal</h4>
                        <p class="card-text">
                          Práctica lectora con avance automático para para practicar y acelerar tu velocidad lectora.
                        </p>
                        <n-button type="primary" @click="goToActivities('2')">¡Vamos!</n-button>
                      </div>
                    </card>
                  </div>

                  <div class="col">
                    <card style="width: 20rem;">
                      <img slot="image" class="card-img-top" src="/img/demo/amigos_thumb.png" alt="Card image cap">
                      <div class="text-primary">
                        <h4 class="card-title">Sinónimos: El obsequio ideal</h4>
                        <p class="card-text">
                          Práctica lectora para para identificar sinónimos.
                        </p>
                        <n-button type="primary" @click="goToActivities('3')">¡Vamos!</n-button>
                      </div>
                    </card>
                  </div>
                </div>

                <div class="row" v-if="taskType == 'resources' && !isShowingVideo">
                  <div class="col">
                    <card style="width: 20rem;">
                      <img slot="image" class="card-img-top" src="/img/demo/video_thumbnail.png" alt="Card image cap">
                      <div class="text-primary">
                        <h4 class="card-title">Desplazamiento de los continentes</h4>
                        <p class="card-text">
                          ¿Sabías que la tierra nunca ha sido igual?.
                        </p>
                        <n-button type="primary" @click="toggleVideo()">¡Vamos!</n-button>
                      </div>
                    </card>
                  </div>

                  <div class="col">
                    <card style="width: 20rem;">
                      <img slot="image" class="card-img-top" src="/img/demo/map-thumbnail.jpg" alt="Card image cap">
                      <div class="text-primary">
                        <h4 class="card-title">Fronteras terrestres y marítimas</h4>
                        <p class="card-text">
                          Conoce las fronteras terrestres y marítimas.
                        </p>
                        <a class="btn btn-primary" href="/img/demo/map-thumbnail.jpg" target="blank">Descargar</a>
                      </div>
                    </card>
                  </div>

                  <!-- <div class="col">
                  <card style="width: 20rem;">
                    <img slot="image" class="card-img-top" src="/img/alcanceBG.png" alt="Card image cap">
                    <div class="text-primary">
                      <h4 class="card-title">Alcance y secuencia</h4>
                      <p class="card-text">
                        Conoce el alcance y la secuencia de Misión Primaria.
                      </p>
                      <a class="btn btn-primary" href="/alcance.pdf" target="blank">Descargar</a>
                    </div>
                  </card>
                </div> -->
                </div>

                <video-viewer v-if="isShowingVideo" />

              </fade-transition>

            </div>
          </div>
        </div>
      </slide-y-up-transition>

    </div>
  </div>
</template>
<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import { SlideYUpTransition, FadeTransition } from 'vue2-transitions';
import Card from '../components/Cards/Card.vue';
import Video from './Video.vue';

export default {
  name: 'mission',
  async created() {
    NProgress.done();
    this.init();
  },
  components: {
    SlideYUpTransition,
    FadeTransition,
    [Video.name]: Video
  },
  data() {
    return {
      isShowingTask: false,
      isShowingVideo: false,
      taskType: ''
    };
  },
  computed: {
    missionId() {
      return this.$route.params.missionId;
    }
  },
  methods: {
    init() {
      let e = localStorage.getItem('userGrade');
    },
    logout() {
      Auth.logout();
    },
    goToBook() {
      this.$router.push(`/preschool/mission/${this.missionId}/libro`);
    },
    goToReadBook() {
      this.$router.push(`/preschool/mission/${this.missionId}/libro-lectura`);
    },
    goToActivity() {
      this.$router.push(`/preschool/mission/${this.missionId}/actividad`);
    },
    goToResources() {
      this.$router.push(`/preschool/mission/${this.missionId}/recursos`);
    },
    selectTask(taskType) {
      this.isShowingTask = true;
      this.taskType = taskType;
    },
    clearTask() {
      if (this.isShowingVideo) {
        this.toggleVideo();
        return;
      }
      this.isShowingTask = false;
      this.taskType = '';
    },
    toggleVideo() {
      this.isShowingVideo = !this.isShowingVideo;
    },
    goToActivities(activityId) {
      this.$router.push(`/mission/${this.missionId}/activities/activity${activityId}`);
    }
  },
}
</script>
<style lang="scss" scoped>
.backBtn {
  position: absolute;
  right: 55px;
  width: 55px;
  height: auto;
  z-index: 9999;

  img {
    width: 35px;
    height: 35px;
    margin: 7.5px;
  }
}

.spacecraft-background {
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}

.spacecraft-container {
  min-width: 100%;
  min-height: 100vh;
  padding-top: 0rem;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraft.png');
  background-size: cover;
  display: flex;
  justify-content: center;
}

.spacecraft-row {
  min-width: 70%;
  max-width: 70%;
  padding-top: 20vw;
  padding-left: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container {
  background-color: darkslategray;
  cursor: pointer;
  border-width: 15px;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  margin-top: 1rem;
  min-height: 10rem;
  min-width: 15rem;
  max-width: 16rem;
  max-height: 11rem;
  border-radius: 1.5rem;
  border-top-left-radius: 3.5rem;
  border-top-right-radius: 3.5rem;
  background-position: 50% 50%;
  box-shadow: -1vw .5vw 1vw rgba(0, 0, 0, .3);

  &.books:hover {
    transform: scale(1.1) rotate(-10deg) !important;
  }

  &.activities:hover {
    transform: scale(1.1) rotate(0deg) !important;
  }

  &.resources:hover {
    transform: scale(1.1) rotate(10deg) !important;
  }
}

.spacecraft-container-glass {
  min-width: 100%;
  min-height: 100vh;
  padding-top: 0% !important;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraftGlass.png');
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: start;
}

.mission-screen {
  border-style: solid;
  border-color: #17202A;
  border-width: 20px;
  border-radius: 50px;
  min-width: 93%;
  min-height: 80vh;
  margin: auto;
  padding-top: 0;
  padding-bottom: 0rem;
  padding-left: 2rem;
  background-image: url('/img/glass.png');
  background-size: cover;
}

@media (max-width: 1230px) {
  .button-container {
    transform: rotate(0deg) !important;
    margin-top: 1rem !important;
  }

  .spacecraft-row {
    padding-left: 0rem !important;
  }
}
</style>
